export const BigDataAnalytics = ({ size = "16" }: { size?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_109_5562)">
      <path
        d="M1.83333 2C1.83333 1.63267 2.132 1.33333 2.5 1.33333H7.83333V6H12.5V7.33333H13.8333V5.05733L8.776 0H2.5C1.39733 0 0.5 0.897333 0.5 2V16H9.16667V14.6667H1.83333V2ZM9.16667 2.276L11.5573 4.66667H9.16667V2.276ZM3.83333 13.3333V10.6667H5.16667V13.3333H3.83333ZM6.5 13.3333V7.33333H7.83333V13.3333H6.5ZM13.5 8.66667C11.7333 8.66667 10.5 9.078 10.5 9.66667V14.5553C10.5 15.4733 11.594 16 13.5 16C15.406 16 16.5 15.4733 16.5 14.5553V9.66667C16.5 9.078 15.2667 8.66667 13.5 8.66667ZM15.1667 10.5153V11.674C14.9893 11.794 14.4827 11.9993 13.5 11.9993C12.5013 11.9993 12.002 11.8053 11.8333 11.6947V10.5147C12.2987 10.6107 12.8627 10.666 13.5 10.666C14.1373 10.666 14.7013 10.6113 15.1667 10.5153ZM13.5 14.6667C12.576 14.6667 12.0307 14.5113 11.8333 14.4047V13.1193C12.2667 13.2487 12.806 13.3333 13.5 13.3333C14.18 13.3333 14.7253 13.2473 15.1667 13.1127V14.4047C14.9693 14.5113 14.424 14.6667 13.5 14.6667Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_109_5562">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
